import type { GetAllCollectionsOutputDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-all-collections/output.dto'

type CollectionEntry = Pick<
  GetAllCollectionsOutputDTO['allCollections'][number],
  'slug' | 'firstArticleSlug'
>

export function getCollectionEntryHref(collection: CollectionEntry): string {
  if (collection.firstArticleSlug) {
    return `/baza/${collection.slug}/${collection.firstArticleSlug}`
  }

  return `/baza/${collection.slug}`
}
